// Copyright (c) 2022, iPivot, Corp.
'use strict'

import { Route, Routes } from 'react-router-dom'

import Login from 'js/components/login/Login'

const LoginRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
        </Routes>
    )
}

export default LoginRoutes
